<template lang="pug">
div(v-if="isPrepaid").prepaid-document-details
  .product-details-rows
    .product-details-row-label
      strong {{$t('Продукт')}}:
    .product-details-row-value  {{document.prepaid.skudata.productName}}
    .product-details-row-label
      strong {{$t('Номер лицензии')}}:
    .product-details-row-value {{document.prepaid.result.serial}}
    .product-details-row-label
      strong {{$t('Код активации')}}:
    .product-details-row-value {{document.prepaid.result.code}}

</template>

<script lang="ts">
import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

@Component({
  name: "PrepaidDocumentDetails"
})
export default class PrepaidDocumentDetails extends Vue {
  @Prop({required:true})
  document: any

  get isPrepaid() {
    return Boolean(this.document.prepaid)
  }

}
</script>

<style scoped lang="less">
@import "legacy-style/src/mixins/mixins";


.prepaid-document-details {
  border: 1px solid rgba(128, 189, 28, 0.51);
  .border-radius(5px);
  margin-top: 10px;
  padding: 20px 20px;

  .product-details-rows {
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-gap: 7px 15px;
    .product-details-row-label {

    }

    .product-details-row-value {
      user-select: all;
      white-space: normal;
      word-break: break-word;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "Продукт": "Product",
    "Номер лицензии": "Serial number",
    "Код активации": "Activation code"
  }
}
</i18n>
